import type * as React from 'react';
import { del } from '@Domain/Api';
import staffMemberDeleted, {
	type StaffMemberDeletedAction,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMemberDeleted';
import staffMemberDeletionFailed, {
	type StaffMemberDeletionFailedAction,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMemberDeletionFailed';
import type DeleteStaffMember from '@Application/Facilities/StaffMembers/StaffMembers/Commands/DeleteStaffMember';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = StaffMemberDeletedAction | StaffMemberDeletionFailedAction;

export default (command: DeleteStaffMember) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/staff-members/${command.staffMemberId}`,
			);

			const action = staffMemberDeleted(
				{ staffMemberId: command.staffMemberId },
				command.organizationId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = staffMemberDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
